export enum Constants {
    INCREMENT_LOADING_COUNTER= 'INCREMENT_LOADING_COUNTER',
    DECREMENT_LOADING_COUNTER= 'DECREMENT_LOADING_COUNTER',
    RESET_COUNTER = 'RESET_COUNTER'
}
